// staging: https://stagingservice.dentagenix.com/   live: https://service.dentagenix.com/
// const ServicePath = process.env.REACT_APP_SERVICE_URL as string
const ServicePath = "https://stagingservice.dentagenix.com/"
// const ServicePath = "https://service.dentagenix.com/"
// const ServicePath = "http://localhost:9015/"

export default ServicePath
